import { styled } from '@atom-web/core'
import { Box, Input as PYTInput } from '@atom-web/micros'
import { useEffect, useMemo, useState } from 'react'

import isIxigoPartnersSite from '../../../utils/isIxigoPartnersSite'
import isEmpty from '../../../utils/lodashUtils/isEmpty'
import omit from '../../../utils/lodashUtils/omit'
import Spin from '../../apollo/spin'

const InputWrapper = styled(Box, {
	position: 'relative',
	height: '55px',
})

const Label = styled('label', {
	position: 'absolute',
	top: '50%',
	left: '$4',
	color: '$grey08',
	fontSize: '$3',
	transition: '0.2s all',
	cursor: 'text',
	pointerEvents: 'none',
})

const LoaderWrapper = styled(Box, {
	position: 'absolute',
	top: '25%',
	right: '$4',
})

export default ({
	onChange,
	placeholder,
	value,
	disabled,
	animated = true,
	wrapperProps,
	inputProps,
	labelProps,
	isLoading = false,
	ignoreCheck = false,
	onKeyDown,
	defaultValue,
}) => {
	const isIxigoPartnersSiteValue = isIxigoPartnersSite()

	const [focus, setFocus] = useState(false)
	useEffect(() => {
		if (value) {
			setFocus(true)
		}
	}, [value])

	const cssProps = useMemo(() => inputProps?.css, [inputProps])
	const restProps = useMemo(() => omit(inputProps, 'css'), [inputProps])

	return (
		<InputWrapper {...wrapperProps} onFocus={() => setFocus(true)}>
			<PYTInput
				defaultValue={defaultValue ? defaultValue : ''}
				onKeyDown={onKeyDown}
				appearance="1"
				onChange={e =>
					e.target.validity.valid || ignoreCheck
						? onChange && onChange(e.target.value)
						: null
				}
				onFocus={() => setFocus(true)}
				onBlur={() => (isEmpty(value) ? setFocus(false) : setFocus(true))}
				value={value}
				autoComplete="off"
				placeholder={!animated ? placeholder : undefined}
				css={{
					paddingLeft: focus ? '$4' : 0,
					paddingTop: focus ? '$3' : 0,
					fontSize: '15px',
					fontWeight: '$semibold',
					color: '$grey12',
					borderRadius: '$4',
					height: '100%',
					backgroundColor: '$custom04',
					border: '1px solid',
					borderColor: '$grey02',
					boxShadow: 'unset',
					lineHeight: '$1',
					'&:focus': {
						border: 'none',
						fontSize: '16px',
					},
					'&:placeholder': {
						fontWeight: '$semibold',
						color: '$grey12',
					},
					zIndex: 99,
					...cssProps,
				}}
				readOnly={disabled}
				id="name"
				{...restProps}
			/>
			{animated && (
				<Label
					htmlFor="name"
					css={{
						top: focus ? '$2' : '$5',
						fontSize: focus ? '$1' : '$2',
					}}
					{...labelProps}
				>
					{placeholder}
				</Label>
			)}
			{isLoading && (
				<LoaderWrapper>
					<Spin
						color={isIxigoPartnersSiteValue ? '#FF8C68' : '#09B367'}
						type="loading"
						width={24}
						height={24}
					/>
				</LoaderWrapper>
			)}
		</InputWrapper>
	)
}
